import { useMemo } from "react";

import { EventTravelLegType } from "Bands/types";
import { ITravelMarker } from "shared/types";

export const useTravelMarkers = (travelLegs?: EventTravelLegType[]) => {
  const markers: ITravelMarker[] = useMemo(() => {
    const travelMarkers: ITravelMarker[] = [];

    travelLegs?.forEach(({ id, departure, arrival }) => {
      const departureId = `${id}-departure`;
      const arrivalId = `${id}-arrival`;

      travelMarkers.push({
        id: departureId,
        coordinates: {
          latitude: departure.location.data.attributes.latitude,
          longitude: departure.location.data.attributes.longitude,
        },
        departure,
        arrival,
      });

      travelMarkers.push({
        id: arrivalId,
        coordinates: {
          latitude: arrival.location.data.attributes.latitude,
          longitude: arrival.location.data.attributes.longitude,
        },
        departure,
        arrival,
      });
    });

    return travelMarkers;
  }, [travelLegs]);

  return { markers };
};
